import React, { Component } from 'react';
import { TabBar } from 'antd-mobile';

export  class Footer extends Component {
  constructor(props){
    super(props);
 
    this.state={
      tabs:[
        {tabName:'首页',id:'home'},
        {tabName:'医院',id:'hospital'},
        {tabName:'套餐',id:'package'},
        {tabName:'购物车',id:'shopping'},
        {tabName:'我的',id:'members'},
      ],
      current:0,
      selectedTab: typeof(this.props.selectedTab)==='undefined'?'home':this.props.selectedTab,
      hidden: false,
      fullScreen: true,
    };
  }

  render() {
   var tabsList= this.state.tabs.map((item,index) =>{
    const tabUrl=  require('../../res/images/bar_'+item.id+'_off.png');
    const selectedUrl=  require('../../res/images/bar_'+item.id+'_on.png');
      return (
          <TabBar.Item
          title={item.tabName}
          key={index}
          selectedIcon={<div style={{
          width: '22px',
          height: '22px',
          background: 'url('+selectedUrl+') center center /  21px 21px no-repeat' }}
        />
        }
       icon={<div style={{
          width: '22px',
          height: '22px',
          background: 'url('+tabUrl+') center center /  21px 21px no-repeat' }}
        />
        }
        selected={this.state.selectedTab === item.id}
        onPress={() => {
          this.setState({
            selectedTab: item.id,
          });          
          window.location.href =item.id==='home'? "/" : "/"+item.id;    
        }}
         ></TabBar.Item>
      );
    });
    return (
      <div style={this.state.fullScreen ? { position: 'fixed', height: '40', width: '100%', bottom: 0 } : { height: window.screen.height-50 }}>      
      <TabBar
      unselectedTintColor="#949494"
      tintColor="#32a128"
      barTintColor="white"
      hidden={this.state.hidden}
      tabBarPosition="bottom"
    >
          {tabsList}
       </TabBar>
       </div>
    );
  }

}